<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedValue !== null" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold Type
        .px-1.neutral400--text |
        .text-xs.primary--text.font-medium {{ displayValue }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold Type

    .white
      .font-semibold.text-sm.px-4.pt-4.pb-2 Filter by type
      div
        .d-flex.text-sm.py-2.px-4
          yz-checkbox(v-model="isConsolidated" @change="updateSelection('consolidated')")
          .ml-4 Consolidated
        v-divider.basic300
      .pb-2
        .d-flex.text-sm.py-2.px-4
          yz-checkbox(v-model="isSingle" @change="updateSelection('single')")
          .ml-4 Single

    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="isConsolidated || isSingle" @click="clear") Clear
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="!isConsolidated && !isSingle") Apply
</template>

<script>
export default {
  name: 'FilterType',
  props: {
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    showMenu: false,
    isConsolidated: null,
    isSingle: null,
    selectedValue: null,
  }),
  computed: {
    displayValue() {
      if (this.selectedValue === 'consolidated') return 'Consolidated'
      if (this.selectedValue === 'single') return 'Single'
      return ''
    }
  },
  watch: {
    filter: {
      handler(val) {
        if (!val?.key) {
          this.clearData()
        }
      },
      deep: true
    }
  },
  methods: {
    updateSelection(value) {
      if (value === 'consolidated') {
        this.isConsolidated = true
        this.isSingle = false
      } else if (value === 'single') {
        this.isSingle = true
        this.isConsolidated = false
      }
    },
    clearData() {
      this.isConsolidated = null
      this.isSingle = null
      this.selectedValue = null
    },
    clear() {
      this.clearData()
      this.$emit('update:filter', {})
    },
    apply() {
      this.showMenu = false
      if (this.isConsolidated) {
        this.selectedValue = 'consolidated'
      } else if (this.isSingle) {
        this.selectedValue = 'single'
      }
      this.$emit('update:filter', { key: 'type', value: this.selectedValue })
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
</style>
